import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import formValueSelector from 'redux-form/es/formValueSelector';
import findIndex from 'lodash/findIndex';
import EducationWorkDetails from 'components/Credit24/LoanApplication/EducationWorkDetailsAU';
import { educationTypes, employmentDurationTypes, workStatuses } from 'consts';

const propTypes = {
  occupation: PropTypes.string,
  hasSecondJob: PropTypes.bool,
};

const EducationWorkDetailsAUContainer = (props) => {
  const { occupation } = props;
  const itemIndex = findIndex(workStatuses, (item) => item.type === occupation);
  const workingStateType = workStatuses[itemIndex] ?? {};
  const isOcm = useSelector((state) => state.loan.channel === 'OCM-WEB');

  const isOcmOrUpgrade = isOcm || INCREASE_APP;

  let companyNameTitle = 'company_name.title';
  let employmentDurationTitle = 'employment_duration.title';

  if (occupation === 'SELF_EMPLOYED') {
    companyNameTitle = 'company_name.title.self_employed';
    employmentDurationTitle = 'employment_duration.title.self_employed';
  }

  const filteredWorkStatuses = isOcmOrUpgrade
    ? workStatuses.filter((item) => item.type !== 'CASUAL')
    : workStatuses;

  return (
    <EducationWorkDetails
      educationTypes={educationTypes}
      workingStateTypes={filteredWorkStatuses}
      employmentDurationTypes={employmentDurationTypes}
      areDetailsNeeded={workingStateType.areDetailsNeeded}
      hasSecondJob={props.hasSecondJob}
      companyNameTitle={companyNameTitle}
      employmentDurationTitle={employmentDurationTitle}
    />
  );
};

EducationWorkDetailsAUContainer.propTypes = propTypes;

const selector = formValueSelector('loan');

export default connect(
  (state) => ({
    occupation: selector(state, 'occupation'),
    hasSecondJob: selector(state, 'secondJob') === 'yes',
  })
)(EducationWorkDetailsAUContainer);
